import {ProductData, ProductElement, ProductElementParamType} from "../../product-types";
import vaseImage from "../../../../images/products/669cf6a1cab037efa533f539.svg";
import {maxPrintHeight} from "../../../consts";
import {vase} from "./elements/vase";

const elements: ProductElement[] = [
    {
        title: 'Gładka ściana bez napisu',
        generatorFunction: (radius, values) => vase(radius, values),
        modifiers: [],
        params: [
            {
                type: ProductElementParamType.HORIZONTAL_RANGE,
                key: 'height',
                name: 'Wysokość',
                unit: 'cm',
                step: 1,
                defaultValue: 10,
                minValue: 10,
                valMapper: val => val / 10,
                maxValue: maxPrintHeight
            },
            {
                type: ProductElementParamType.HORIZONTAL_RANGE,
                name: 'Ilość wcięć',
                key: 'count',
                step: 1,
                defaultValue: 30,
                minValue: 10,
                valMapper: val => val,
                maxValue: 100
            },
            {
                type: ProductElementParamType.HORIZONTAL_RANGE,
                name: 'Poziom nachylenia wcięć',
                key: 'twistAmount',
                defaultValue: 0,
                step: 0.05,
                minValue: -0.15,
                valMapper: val => val * 10,
                maxValue: 0.15
            }
        ]
    },
]

export const SPIRAL_VASE: ProductData = {
    id: '2',
    title: 'Vase',
    state: 'NEW',
    icon: vaseImage,
    maxElements: 1,
    elements,
    disabled: true,
    description: "Stwórz przytulny klimat w swoim domu dzięki naszej doniczce w stylu boho. Wykonana z naturalnych, biodegradowalnych materiałów. Doskonale nadaje się do postawienia na balkonie czy altanie. Delikatne, pastelowe kolory – różowy, miętowy i jasnobeżowy – dodadzą Twojemu wnętrzu subtelnego uroku.",
    images: [
        "https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/1.png",
        "https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/2.png",
        "https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/3.png"
    ],
    details: [
        "Produkt stworzony z materiałów biodegradowalnych.",
        "Doniczki pokryte są warstwą żywicy zapobiegającą przeciekaniu oraz chroniącą przed słońcem.",
        "Tutaj 3 opis."
    ],
    policies: [],
    default: [
        {
            config: elements[0],
            values: {
                height: 180,
                count: 45,
                twistAmount: 0
            },
            modifiers: [],
        },
    ]
}